import { BusinessPaymentOptions } from '@/models/businesses/business-payment-options';
import { BusinessPaymentOptionsSummary } from '@/models/businesses/business-payment-options-summary';
import { BankTransferPaymentConfig } from '@/models/common/bank-transfer-payment-config';
import { PaymentBasics } from '@/models/common/payment-basics';
import { PayPalPaymentConfig } from '@/models/common/paypal-payment-config';
import { PersonalBizumPaymentConfig } from '@/models/common/personal-bizum-payment-config';
import { RedsysPaymentConfig } from '@/models/common/redsys-payment-config';
import { axiosService } from '.';
import { PaymentOnHandingOver } from '@/models/common/payment-on-handing-over';

export default class BusinessPaymentOptionsService {
    public async getPaymentOptions(businessId: number): Promise<BusinessPaymentOptions> {
        return new BusinessPaymentOptions((await axiosService.instance.get(`businesses/organization/payment-options/${businessId}`)).data);
    }

    public async getPaymentOptionsSummary(businessId: number): Promise<BusinessPaymentOptionsSummary> {
        const businessPaymentOptionsSummaryData = (await axiosService.instance.get(`businesses/organization/payment-options/${businessId}/summary`)).data;
        return new BusinessPaymentOptionsSummary(businessPaymentOptionsSummaryData ? businessPaymentOptionsSummaryData : { businessId });
    }

    public async updatePaymentBasics(id: number, paymentBasics: PaymentBasics): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/payment-basics/${id}/update`, paymentBasics)).data;
    }

    public async updateBankTransferPaymentConfig(id: number, bankTransferPaymentConfig: BankTransferPaymentConfig): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/bank-transfer-payment-config/${id}/update`, bankTransferPaymentConfig)).data;
    }

    public async updatePayPalPaymentConfig(id: number, payPalPaymentConfig: PayPalPaymentConfig): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/pay-pal-payment-config/${id}/update`, payPalPaymentConfig)).data;
    }

    public async updateRedsysPaymentConfig(id: number, redsysPaymentConfig: RedsysPaymentConfig): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/redsys-payment-config/${id}/update`, redsysPaymentConfig)).data;
    }

    public async updatePersonalBizumPaymentConfig(id: number, personalBizumPaymentConfig: PersonalBizumPaymentConfig): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/personal-bizum-payment-config/${id}/update`, personalBizumPaymentConfig)).data;
    }

    public async updatePaymentOnHandingOver(id: number, paymentOnHandingOver: PaymentOnHandingOver): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/payment-on-handing-over/${id}/update`, paymentOnHandingOver)).data;
    }
}

export const businessPaymentOptionsService = new BusinessPaymentOptionsService();
